import React from 'react';
import List from './list';
import ListDetailsSubLayout from '../../layout/ListDetailSubLayout';
import Details from './details';
import AgentApprovalList from './components/AgentApprovalList';
import AgentApprovalDetails from './components/AgentApprovalDetails';
import useUserStore from '../../stores/user';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import CloseIconWhite from '../../assets/svg/icons/common/CloseIconWhite';
import styles from './style.module.scss';

const ManagerApprovalPage = () => {
  const isAgent = useUserStore((state) => state.isAgent);

  return (
    <>
      <ListDetailsSubLayout 
        listComponent={isAgent ? AgentApprovalList : List} 
        detailsComponent={isAgent ? AgentApprovalDetails : Details} 
      />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            borderRadius: "8px",
            background: "rgba(40, 39, 45, 0.85)",
            color: "#fff",
            padding: "16px 24px",
          },
          duration: 5000,
        }}
      >
        {(t) => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <>
                {icon}
                {message}
                {t.type !== "loading" && (
                  <button
                    className={styles.toast_dismissal_button}
                    onClick={() => toast.dismiss(t.id)}
                    type="button"
                  >
                    <CloseIconWhite />
                  </button>
                )}
              </>
            )}
          </ToastBar>
        )}
      </Toaster>
    </>
  );
};

export default ManagerApprovalPage;